import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f8cb7e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "genre" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"options-title\" data-v-0f8cb7e8><div class=\"title\" data-v-0f8cb7e8>工单类型分析</div></div><div class=\"content\" data-v-0f8cb7e8><div class=\"area-chart\" data-v-0f8cb7e8><div id=\"ringChart\" data-v-0f8cb7e8></div><div id=\"areaChart\" data-v-0f8cb7e8></div></div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

import {
  computed, reactive, ref, watch, onMounted, onUnmounted,
} from 'vue';
import { DatePicker, Select, ConfigProvider, } from 'ant-design-vue';
import moment, { Moment, } from 'moment';
import Highcharts from 'highcharts';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

import Highcharts3d from 'highcharts/highcharts-3d';
import { useStore, } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

Highcharts3d(Highcharts);

const ringChart = ref<any>(null);
const areaChart = ref<any>(null);

const statisticsGenre = computed(() => store.state.ticket.statisticsGenre);

watch(statisticsGenre,(val) => {
  const { orderType = [],createType = [], } = val;

  const orderSum = orderType.reduce((ans:number,cur:any) => ans + cur.num,0);

  if (ringChart.value) {
    ringChart.value.series[0].update({
      data: orderType.map((cur:any) => [cur.typeName, Number(cur.num / orderSum) * 100,]),
    });
  }
  if (areaChart.value) {
    areaChart.value.series[0].update({
      data: createType.map((cur:any) => [cur.typeName, Number(cur.num / orderSum) * 100,]),
    });
  }
});

const customDate = computed(() => store.state.ticket.customDate);
const userInfo = computed(() => store.state.login.userInfo);

const updated = (val:any) => {
  ringChart.value.title.update({
    text: `${moment(val[0]).format('YYYY年MM月DD日')}-${moment(val[1]).format('YYYY年MM月DD日')}工单业务类型分析`,
  });
  areaChart.value.title.update({
    text: `${moment(val[0]).format('YYYY年MM月DD日')}-${moment(val[1]).format('YYYY年MM月DD日')}工单创建类型分析`,
  });
  store.dispatch('ticket/statisticOrderTypeAnalysis', {
    startTime: moment(val[0]).format('YYYY-MM-DD'),
    endTime: moment(val[1]).format('YYYY-MM-DD'),
    userId: userInfo.value.id,
    selectType: 1,
  });
};

watch(customDate, (val) => {
  updated(val);
});

// draw charts
const ringOption = {
  chart: {
    type: 'pie',
    options3d: {
      enabled: true,
      alpha: 62,
    },
  },
  title: {
    text: 'X月工单业务类型分析',
    y: 10,
    style: {
      color: '#1D2129',
      fontSize: '.16rem',
      fontWeight: '600',
    },
  },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
    style: {
      color: '#1D2129',
      fontSize: '.13rem',
      // 'font-family': 'Impact',
      'font-weight': '400',
    },
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      innerSize: 100,
      depth: 38,
      showInLegend: true,
    },
    series: {
      dataLabels: {
        enabled: true,
        format: '{point.name}: {point.percentage:.1f}%',
        style: {
          color: '#1D2129',
          fontSize: '.13rem',
          // 'font-family': 'Impact',
          'font-weight': '400',
        },
      },
    },
  },
  credits: {
    enabled: false,
  },
  colors: [
    '#CA9DFA',
    '#F3798C',
    '#66D187',
    '#51D1D1',
    '#57AFFF',
    '#ff9696',
    '#e4d354',
    '#8085e8',
    '#8d4653',
    '#91e8e1',
  ],
  legend: {
    layout: 'vertical',
    y: 10,
    backgroundColor: '#FFFFFF',
    floating: true,
    align: 'right',
    verticalAlign: 'middle',
    itemStyle: {
      cursor: 'pointer',
      color: '#1D2129',
      fontSize: '.14rem',
      lineHight: '.3rem',
      'font-family': 'PingFang SC',
      'font-weight': '400',
    },
    // hover图例样式
    itemHoverStyle: { color: '#5D98F7', },
    // 隐藏图例样式
    itemHiddenStyle: { color: '#888', },
    // 图例文字间隔
    symbolPadding: 10,
    // 图例前圆角
    symbolRadius: 0,
    // 每一项间隔高度
    itemMarginBottom: 2,
  },
  series: [
    {
      name: '类型占比',
      data: [],
    },
  ],
};

const areaOption = {
  chart: {
    type: 'pie',
    options3d: {
      enabled: true,
      alpha: 62,
      beta: 0,
    },
  },
  title: {
    text: 'X月工单创建类型分析',
    y: 10,
    style: {
      color: '#1D2129',
      fontSize: '.16rem',
      fontWeight: '600',
    },
  },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
    style: {
      color: '#1D2129',
      fontSize: '.13rem',
      'font-weight': '400',
    },
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      depth: 38,
      showInLegend: true,
    },
    series: {
      dataLabels: {
        enabled: true,
        format: '{point.name}: {point.percentage:.1f}%',
        style: {
          color: '#1D2129',
          fontSize: '.13rem',
          'font-weight': '400',
        },
      },
    },
  },
  legend: {
    layout: 'vertical',
    y: 30,
    backgroundColor: '#FFFFFF',
    floating: true,
    align: 'right',
    verticalAlign: 'middle',
    itemStyle: {
      cursor: 'pointer',
      color: '#1D2129',
      fontSize: '.14rem',
      lineHight: '.3rem',
      'font-family': 'PingFang SC',
      'font-weight': '400',
    },
    // hover图例样式
    itemHoverStyle: { color: '#5D98F7', },
    // 隐藏图例样式
    itemHiddenStyle: { color: '#888', },
    // 图例文字间隔
    symbolPadding: 10,
    // 图例前圆角
    symbolRadius: 0,
    // 每一项间隔高度
    itemMarginBottom: 2,
  },
  colors: [
    '#54BC94',
    '#5D98F7',
    '#66D187',
    '#51D1D1',
    '#57AFFF',
    '#ff9696',
    '#e4d354',
    '#8085e8',
    '#8d4653',
    '#91e8e1',
  ],
  credits: {
    enabled: false,
  },
  series: [
    {
      type: 'pie',
      name: '类型占比',
      data: [],
    },
  ],
};

onMounted(() => {
  const container = document.getElementById('ringChart') as HTMLElement;
  const areaContainer = document.getElementById('areaChart') as HTMLElement;
  const hc:any = Highcharts;

  ringChart.value = hc.chart(container, ringOption);
  areaChart.value = hc.chart(areaContainer, areaOption);

  updated(customDate.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})